import 'commercial-web-client-utilities/dist/compat';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer';

import { createApp } from 'vue';
import { ComponentMapping, MapTo } from 'aem-vue-editable-components';
import App from './app.vue';
import { appStorePlugin, developerSettingsStorePlugin } from './store';
import { createPinia } from 'pinia';
import i18n from './i18n';
import { registerApp } from './composables/plugin';
import { mountComponent } from './composables/mount-component';
import { BootstrapVue } from 'bootstrap-vue';

import '@fortawesome/fontawesome-free/css/all.css';

import {
    authenticationService, commwebService, ledsService, monitoringService, nonsecureService
} from '@/composables/service';
import { commonComponentsPlugin } from 'commercial-web-client-common-components';

import { onNativeDirective } from 'commercial-web-client-utilities/dist/directives/on-native';
import { createSsoRouter } from 'commercial-web-client-utilities/dist/composables/sso-router';
import { createAemLayoutController } from 'commercial-web-client-utilities/dist/composables/aem-layout-controller';
import { createAppNotifications } from 'commercial-web-client-utilities/dist/composables/app-notifications';

import type { Plugin } from 'vue';

const pinia = createPinia();
const app = createApp(App);
registerApp(app);

app.use(i18n);
app.use(BootstrapVue as unknown as Plugin);
app.use(commonComponentsPlugin);
app.use(pinia);
app.use(appStorePlugin);
app.use(developerSettingsStorePlugin);
app.use(authenticationService);
app.use(commwebService);
app.use(ledsService);
app.use(monitoringService);
app.use(nonsecureService);
app.use(createSsoRouter({ ledsService, monitoringService }));
app.use(createAemLayoutController());
app.use(createAppNotifications());

app.directive('on-native', onNativeDirective);

if (document.getElementById('commercial-web-public-app')) {
    app.mount('#commercial-web-public-app');
}

// Certain APIs need to be exposed on global scope. Exposing them through the app instance.
(window as unknown as { commercialWebPublicApp: unknown }).commercialWebPublicApp = app;

// Expose an API for AEM component to be able to mount a Vue component anywhere on the page.
window.commercialWebPublicApp.mountComponent = mountComponent;

// Expose AEM component mapping for debugging.
window.commercialWebPublicApp.ComponentMapping = ComponentMapping;
window.commercialWebPublicApp.MapTo = MapTo;
